import React, { useContext } from 'react';
import { AppDataContext } from 'contexts/appData';
import { Stats } from './components/Stats';
import { Info } from './components/Info';
import { Actions } from './components/Actions';
import { Recommendations } from './components/Recommendations';
import { ReactComponent as CloseIcon } from '../../../../resources/img/icons/close_new_modal.svg';
import { useMediaQuery } from 'libs';
import { AnalyticsProvider } from './AnalyticsProvider';
import clsx from 'clsx';

const Analytics = (props) => {
  const { langs } = useContext(AppDataContext);
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <AnalyticsProvider productId={props.data.currentProductId}  setProductId={props.data.setCurrentProductId}>
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div className="position-relative">
          <div className="d-block d-md-none" style={{ width: 57, borderRadius: 6, height: 3, background: '#D9D9D9', margin: '0 auto', marginTop: 8 }}></div>
          <div className="bg-white py-18px py-md-24px container" style={{ borderBottom: '1px solid #EEE' }}>
            <div className="d-flex align-items-center justify-content-center justify-content-md-start">
              <div className="font-bold font-size-16 font-size-md-24 ml-20px">{langs?.NM_AnalyticsTitle}</div>
            </div>
          </div>
          <div
            className="modal-close-button right-lg-48px right-16px right-md-30px w-24px h-24px w-md-32px h-md-32px mt-8px mt-md-0 position-absolute cursor-pointer d-flex justify-content-center align-items-center ml-auto"
            onClick={props.close}
          >
            <CloseIcon />
          </div>
        </div>

        <div style={{ backgroundColor: '#F6F6F6', paddingTop: '16px', flex: 1, overflowY: 'auto', paddingBottom: '24px' }}>
          <div className={clsx({ container: !isMobile })}>
            <div className="d-flex gap-16px flex-wrap flex-lg-nowrap">
              <div style={{ display:'flex', flexDirection: 'column', flex: '0 1 auto', minWidth: 0, width: '100%' }}>
                <Info />
                <Stats />
              </div>

              <Recommendations />
            </div>

            <Actions onClose={props.close} />
          </div>
        </div>
      </div>
    </AnalyticsProvider>
  );
};

export default Analytics;
